/**
 * Helpers for cross-origin postMessage communication between this page
 * (running inside an iframe) and the parent WooCommerce store.
 */

/**
 * Resolve the parent (WooCommerce) origin.
 * Passed as ?origin= query param by the WooCommerce plugin.
 * Falls back to "*" when not set (development / direct access).
 */
function getParentOrigin() {
  const params = new URLSearchParams(window.location.search);
  return params.get("origin") || "*";
}

/** Whether this page is running inside an iframe. */
export const isInIframe = window.parent !== window;

/** Send a postMessage to the parent window (no-op when not in an iframe). */
export function sendToParent(data) {
  if (!isInIframe) return;
  window.parent.postMessage(data, getParentOrigin());
}

/**
 * Returns a Promise that resolves when a postMessage with the given `type`
 * arrives from the parent. Rejects after `timeoutMs`.
 */
export function waitForParentResponse(expectedType, timeoutMs = 60000) {
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => {
      window.removeEventListener("message", handler);
      console.error("[ontik-express] Timeout waiting for", expectedType);
      reject(new Error(`Timeout waiting for ${expectedType}`));
    }, timeoutMs);

    function handler(event) {
      const data = event.data;
      if (!data || data.type !== expectedType) return;

      window.removeEventListener("message", handler);
      clearTimeout(timer);
      resolve(data);
    }

    window.addEventListener("message", handler);
  });
}

/**
 * Notify the parent of content height changes so it can resize the iframe.
 * Measures #adyen-express-container; falls back to document.body.
 */
export function sendResize() {
  const container = document.getElementById("adyen-express-container");
  const height = container ? container.offsetHeight : document.body.scrollHeight;
  sendToParent({ type: "ontik:express:resize", height });
}
